module.exports = __webpack_public_path__ + "img/lightning_symbol.97273f7c.png";